export const convertFilterToPaginateQueryParams = (filters: any): string =>
  Object.entries(filters).reduce<string>((filterString, [filterKey, filterValue]) => {
    if ((Array.isArray(filterValue) && !filterValue.length) || (!filterValue && filterValue !== '$null')) {
      return filterString;
    }
    // URL encode the filter value to handle special characters like $
    const encodedValue = encodeURIComponent(String(filterValue));
    return (filterString += `&filter.${filterKey}=${encodedValue}`);
  }, '');
